export default "<base href=\"/\">\r\n<router-outlet></router-outlet>"